
import { Component, Prop, Vue } from 'vue-property-decorator';
import BoxError from '@/components/box/BoxError/BoxError.vue';

// 記事詳細が連携条件により閲覧できない（API 403）場合の表示（Error404.vue ベース）
@Component({
  components: {
    BoxError,
  },
})
export default class BoxRelationRequired extends Vue {
  @Prop({ type: Object, required: true })
  readonly view!: RestrictionView;

  get buttonTo() {
    const button = this.view.button;
    if (button && button.toLineAuth) {
      // 連携後に、遷移しようとしたページ（今の詳細ページ）へ戻す
      return { path: '/line-auth', query: { from: this.$route.fullPath } };
    }
    return (button && button.to) || '/';
  }
}
